import { useCallback, useEffect, useState } from 'react';
import { garantirLicenca, renovarLicenca, verificarLicenca } from '../data/license';
import { watchConnection } from '../data/local/status';

/**
 * Estado da licença deste computador.
 *
 * Tenta renovar ao abrir e sempre que a conexão volta. Enquanto o vale
 * anterior estiver válido, o app funciona offline normalmente — bloquear é o
 * último recurso, não o primeiro.
 */
export const useLicenca = (laboratoryId) => {
  const [estado, setEstado] = useState('verificando');
  const [motivo, setMotivo] = useState(null);
  const [expiraEm, setExpiraEm] = useState(null);

  const aplicar = useCallback((r) => {
    setEstado(r.valida ? 'ok' : 'bloqueado');
    setMotivo(r.valida ? null : r.motivo);
    setExpiraEm(r.expiraEm || null);
  }, []);

  const verificar = useCallback(async () => {
    if (!laboratoryId) return;
    aplicar(await garantirLicenca(laboratoryId));
  }, [laboratoryId, aplicar]);

  /** Botão "tentar de novo": força a ida ao servidor e mostra o motivo real. */
  const tentarNovamente = useCallback(async () => {
    if (!laboratoryId) return;
    setEstado('verificando');
    const r = await renovarLicenca(laboratoryId);
    if (!r.renovada && r.motivo && r.motivo !== 'sem_conexao') {
      setEstado('bloqueado');
      setMotivo(r.motivo);
      return;
    }
    aplicar(await verificarLicenca());
  }, [laboratoryId, aplicar]);

  useEffect(() => { verificar(); }, [verificar]);

  // Voltou a conexão: é a chance de renovar sem o usuário fazer nada.
  useEffect(() => watchConnection((online) => { if (online) verificar(); }), [verificar]);

  return { estado, motivo, expiraEm, tentarNovamente };
};
